import * as React from 'react';

import { useZerofyNotificationBadges } from '@xingternal/crate-communication-use-zerofy-notification-badges';
import { XingFrameContext } from '@xingternal/frame-data-provider';

const notificationKeysMapX3: Record<string, string> = {
  contacts: 'contactRequests',
  content: 'news',
  events: 'events',
  groups: 'groupsWeb',
  home: 'activities',
  disco: 'insights',
  messages: 'unseenMessages',
  jobs: 'jobs',
  'me-hub': 'meHub',
  premium: 'premiumPerksNew',
  proBusiness: 'probusinessNotifications',
  supi: 'notificationCenterWebVisionType',
};

const notificationKeysMapOld: Record<string, string> = {
  ...notificationKeysMapX3,
  supi: 'networkHome',
};

const Zerofier: React.VFC = () => {
  const {
    activeItem,
    loadingAppStatsQuery,
    changeNotification,
    featureSwitches,
  } = React.useContext(XingFrameContext);

  const { markBadgesAsSeen } = useZerofyNotificationBadges();
  const notificationKeysMap = featureSwitches?.includes('enable_vision_type')
    ? notificationKeysMapX3
    : notificationKeysMapOld;
  const currentNotificationBadge =
    activeItem && notificationKeysMap[activeItem];

  React.useEffect(() => {
    if (!loadingAppStatsQuery && currentNotificationBadge) {
      changeNotification(currentNotificationBadge, 0);
      markBadgesAsSeen([currentNotificationBadge]);
    }
  }, [
    changeNotification,
    loadingAppStatsQuery,
    markBadgesAsSeen,
    currentNotificationBadge,
  ]);

  return <></>;
};

export { Zerofier };
